import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=e3aa1350&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=e3aa1350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aa1350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3aa1350')) {
      api.createRecord('e3aa1350', component.options)
    } else {
      api.reload('e3aa1350', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=e3aa1350&scoped=true&", function () {
      api.rerender('e3aa1350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Nod1hUW22Bya/JS/comp/DocBox.vue"
export default component.exports